import { I18N } from "aurelia-i18n";
import KeyDownEvent = JQuery.KeyDownEvent;
import { activationStrategy } from "aurelia-router";
import { Guid } from "../../../../../utilities/guid";
import { MobileHelper } from "../../../../../helpers/mobile-helper";
import { autoinject, transient } from "aurelia-dependency-injection";
import { CustomGridPageBase } from "../../../common/custom-grid-page.base";
import { BindingEngine, computedFrom, observable } from "aurelia-binding";
import { RatingItem } from "../../../../components/rating-selector/rating-selector";
import { LookupValueQuery } from "../../../../../constants/modules/lookup.constants";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { RightShipQiRouterConstants } from "../../../../../configuration/rightshipqi-router.constants";
import { RightShipDialogServiceConstants } from "../../../../../constants/basics/rightship-dialog.constants";
import { DataGridColumn, DataType, QueryFilter, SourceType } from "../../../../../models/queries/queries.models";
import { MultiLookupModel, RightShipMultiLookupModels } from "../../../../components/multi-checked-list-selector/multi-checked-list-selector";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../../../../configuration/event-messages.constants";
import { ManageRightShipUsersClientService } from "../../../../../services/modules/righship-qi-manage-users.service";
import { SubscriptionProductCodes } from '../../../../../models/customers/customer-subscription.models';
import { PlatformFeatureKeys } from "@rightship-tech/common-ui/dialogs/upgrade-from-freemium/freemium-feature-info-model";
type MultipleFilterListColumn = DataGridColumn & {
    filterActive?: boolean;
};
@autoinject()
@transient()
export class VesselSearch extends CustomGridPageBase{
    
    public getItemRoute = (id) => `/vessel/${id}}`;
    public mobileSelectedFilter: number[] = [];
    public selectedStatusFilter: number[] = [];
    public keywords: string;
    public keywordProperties: string[];
    public filters: MultipleFilterListColumn[];
    public mclFilters: { [lookup: string]: QueryFilter[] } = {};
    public includePreviousVesselNames : boolean = false;
    public isLimitedSubscription: boolean;

    @observable()
    filter: string;
    public initialFilters: QueryFilter[];
    public isMobileFilterOpen: boolean = false;

    public selectedFilter: { title: string, clear: () => void, apply: () => void };

    constructor(i18N: I18N, protected bindingEngine: BindingEngine, private dialogClientService: DialogClientService, private cacheClient: CacheClientService,
        private eventAggregator: EventAggregator, private manageRightShipUsersClientService: ManageRightShipUsersClientService) {
        super(i18N, "Vessel Search", bindingEngine);

        this.columns.push();
        this.initialSorting = this.getSorting();
    }

    public getSorting() {
        let columns: DataGridColumn[] = [];
        columns =  []

        return columns;
    }

    async activate() {
        let filters : QueryFilter[] = []
        const pathKeywords = `search-keywords-${RightShipQiRouterConstants.RouteNames.VesselsSearch}`;
        const pathFilters = `search-filters-${RightShipQiRouterConstants.RouteNames.VesselsSearch}`;
        this.isLimitedSubscription = await this.manageRightShipUsersClientService.isLimitedCustomerSubscription(SubscriptionProductCodes.informationServices);

        try {
            this.keywords = await this.cacheClient.get<string>(pathKeywords, CacheLocation.LocalStorage) ;
        }
        catch(err) {
            this.keywords = "";
        }

        try {
            filters = await this.cacheClient.get<QueryFilter[]>(pathFilters, CacheLocation.LocalStorage) ;
        }
        catch(err) {
            filters = [];
        }

        this.cacheClient.remove(pathKeywords, CacheLocation.LocalStorage);
        this.cacheClient.remove(pathFilters, CacheLocation.LocalStorage);

        this.columns = this.getColumns();
        this.itemSource = this.getItemSource(filters);
        this.updateFilters(filters)
    }

    updateFilters(filters: QueryFilter[]) {
        filters.forEach(filter => {
            switch(filter.filterProperty.name) {
                case 'age' : {
                    if(filter.filterOperator.translatedSymbol == "ge") {
                        this.ageFirstFilter = filter.filterValue
                    }
                    else if(filter.filterOperator.translatedSymbol == "le") {
                        this.ageSecondFilter = filter.filterValue
                    }
                    break;
                }
            
                case 'dwt': {
                    if(filter.filterOperator.translatedSymbol == "ge") {
                        this.dwtFirstFilter = filter.filterValue
                    }
                    else if(filter.filterOperator.translatedSymbol == "le") {
                        this.dwtSecondFilter = filter.filterValue
                    }
                    break;
                }

                case 'inspectionState': {
                    this.selectedStates = filter.filterValue
                    break;
                }

                case 'ghgRatingWeight': {
                    this.selectedGhgRatingWeights = filter.filterValue
                    break;
                }
                
                case 'safetyRating' : {
                    this.selectedSafetyRatings = filter.filterValue
                    break;
                }

                case 'safetyRatingType' : {
                    if(!this.selectedSafetyRatings) {
                        this.selectedSafetyRatings = []
                    }
                    this.selectedSafetyRatings.push(-1)
                    break;
                }

                case 'vesselTypeGroupId' : {
                    if(!this.mclFilters['RS_VesselTypes']) {
                        this.mclFilters['RS_VesselTypes'] = []
                    }
                    this.mclFilters['RS_VesselTypes'].push(filter) 
                    break;
                }

                case 'shipTypeId': {
                    if(!this.mclFilters['RS_VesselTypes']) {
                        this.mclFilters['RS_VesselTypes'] = []
                    }
                    this.mclFilters['RS_VesselTypes'].push(filter) 
                    break;
                }

                case 'vesselStatusGroupId': {
                    if(!this.mclFilters['RS_VesselStatuses']) {
                        this.mclFilters['RS_VesselStatuses'] = []
                    }
                    this.mclFilters['RS_VesselStatuses'].push(filter)
                    break;
                }

                case 'shipStatusId': {
                    if(!this.mclFilters['RS_VesselStatuses']) {
                        this.mclFilters['RS_VesselStatuses'] = []
                    }
                    this.mclFilters['RS_VesselStatuses'].push(filter)
                    break;
                }

                case 'previousName' : {
                    this.includePreviousVesselNames = filter.filterValue? true : false;
                    break;
                }
            }
        })
    }

    getColumns(): DataGridColumn[] {
        return  [
            {
                dataType: DataType.CustomTemplate,
                value: '<div class="column">' +
                    '<a class="link" href="/vessel/${item.vesselId}">${item.name}</a>' +
                    '<span if.bind="item.internationalMaritimeOrganizationNumber">IMO ${item.internationalMaritimeOrganizationNumber}</span>' +
                    '<span if.bind="item.vehicleIdentificationNumber">VIN ${item.vehicleIdentificationNumber}</span>' +
                    '<span if.bind="item.europeanNumberOfIdentification">ENI ${item.europeanNumberOfIdentification}</span>' +
                    '</div>',
                name: "name",
                title: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "Name",
                instancePerRow: true,
                sortOrder: 2,
                columnOrder: -1,
                isHidden: false,
                isSortable: true,
                parameter: {
                    item: null
                }
            },
            {
                    dataType: DataType.CustomTemplate,
                    value: '<comp-safety-score score.bind="item.safetyRating" inspection.bind="item" safety-rating-indicative.bind="item.safetyRatingIndicative" safety-score-type.bind="item.safetyRatingType" incident-grace-periods.bind="getIncidentGracePeriods(item)"' +
                        'has-error.bind="item.hasError" is-condensed="true" unlock-feature-key="vessels-search" mask-data.bind="maskData(item.safetyRating)" locked-feature.bind="lockedFeature"></comp-safety-score>',
                    name: "safetyRating",
                    title: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "Safety Score",
                    instancePerRow: true,
                    sortOrder: 1,
                    columnOrder: 1,
                    isHidden: false,
                    isSortable: true,
                    parameter: {
                        item: null,
                        lockedFeature: this.isLimitedSubscription,
                        maskData: (safetyRating) => {{
                            return safetyRating === undefined;
                        }},
                        getIncidentGracePeriods: (item) => {
                            return item.incidentGracePeriodJsonData ? JSON.parse(item.incidentGracePeriodJsonData) : [];
                        }
                    },
                    width: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "220px"
            },
            {
                    dataType: DataType.CustomTemplate,
                    value: '<comp-ghg-rating rating.bind="item.ghgRating" rating-plus.bind="item.isGhgRatingPlus" ' +
                        'is-verified.bind="item.isGhgRatingVerified" is-eexi-applicable.bind="item.isEexApplicable" is-eexi-compliant.bind="item.isEexiCompliant" ' +
                        'eexi-compliance-type.bind="item.eexiComplianceTypeId" show-eexi-banner.bind="true" unlock-feature-key="vessels-search" locked-feature.bind="lockedFeature" mask-data.bind="maskData(item.ghgRating)"></comp-ghg-rating>',
                    name: "ghgRatingWeight",
                    title: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "GHG Rating",
                    instancePerRow: true,
                    sortOrder: 2,
                    columnOrder: 2,
                    isHidden: false,
                    isSortable: true,
                    parameter: {
                        item: null,
                        lockedFeature: this.isLimitedSubscription,
                        maskData: (ghgRating) => {{
                            return ghgRating === undefined;
                        }}
                    },
                    width: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "140px"
            },
            {
                columnOrder: 3,
                sortOrder: 3,
                dataType: DataType.Default,
                name: 'vesselType',
                title: 'Vessel Type',
                isSortable: true
            },
            {
                columnOrder: 4,
                sortOrder: 4,
                dataType: DataType.CustomTemplate,
                value: "<span>${roundFigure(item.dwt).toLocaleString()}</span>",
                name: 'dwt',
                title: 'DWT',
                isSortable: true,
                instancePerRow: true,
                parameter: {
                    item: null,
                    roundFigure: (dwt) => {{
                        return Math.round(dwt);
                    }}
                },
            },
            {
                columnOrder: 5,
                sortOrder: 5,
                dataType: DataType.CustomTemplate,
                value:"<span>${item.age}y/o (${item.yearOfConstruction})</span>",
                // instancePerRow: true,
                name: 'age',
                title: 'Age',
                isSortable: true,
                instancePerRow: true,
                parameter: {
                    item: null
                },
            },
            {
                columnOrder: 6,
                sortOrder: 6,
                dataType: DataType.Default,
                name: 'shipStatus',
                title: 'Vessel Status',
                isSortable: true
            },
        ]
    }

    private getItemSource(filters) {
        this.initialFilters = filters;
        return {
            sourceType: SourceType.ODataUrl,
            source: "odata/VesselSearch",
            columns: this.columns,
            initialSorting: this.initialSorting,
            initialFilters: filters
        };
    }

    private setItemSource() {
        let currentFilters: QueryFilter[] = [];
       
        if (this.keywords) {
            const guid = Guid.generateGuid();

            currentFilters.push(QueryFilter.getQuery("name", this.keywords, "contains({0}, '{1}')", DataType.Default, true, false, guid, true, true))
            currentFilters.push(QueryFilter.getQuery("internationalMaritimeOrganizationNumber", this.keywords, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true))
            currentFilters.push(QueryFilter.getQuery("europeanNumberOfIdentification", this.keywords, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true))
            currentFilters.push(QueryFilter.getQuery("vehicleIdentificationNumber", this.keywords, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true))
            currentFilters.push(QueryFilter.getQuery("previousName", this.includePreviousVesselNames ? this.keywords : null, "contains({0}, '{1}')", DataType.Default, false, false, guid, true, true));   
        }

        //#region safety rating filter
        if (this.selectedSafetyRatings && this.selectedSafetyRatings.length > 0) {
            this.previousSafetyRatings = this.selectedSafetyRatings;
            const guid = Guid.generateGuid();
            const hasSafetyRating : boolean = this.selectedSafetyRatings.filter(x => x >= 0).length > 0;
            if(hasSafetyRating) {
                const safetyRatingFilter: QueryFilter = {
                    filterOperator: {
                        translatedSymbol: "{0} in ({1})",
                        friendlyName: "in",
                        requiresFilterValue: true,
                        requiresInterpolation: true
                    },
                    filterProperty: {
                        name: "safetyRating",
                        isDynamicProperty: false,
                        type: DataType.Number,
                        isNullable: true,
                    },
                    filterValue: this.selectedSafetyRatings.filter(x => x >= 0),
                    isAnd: true,
                    skipOnNullOrEmpty: true,
                    groupGuid: guid
                };
                currentFilters.push(safetyRatingFilter);
            }

            const isIncludeNa : boolean = this.selectedSafetyRatings.indexOf(-1) >= 0;
           
            const naFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: isIncludeNa? "{0} in ({1})" : "ne",
                    friendlyName: isIncludeNa? "in": "<>",
                    requiresFilterValue: true,
                    requiresInterpolation: isIncludeNa
                },
                filterProperty: {
                    name: "safetyRatingType",
                    isDynamicProperty: false,
                    type: DataType.Number,
                    isNullable: true,
                },
                filterValue: isIncludeNa? [-1] : -1,
                isAnd: isIncludeNa? (hasSafetyRating ? false : true) : true,
                skipOnNullOrEmpty: true,
                groupGuid: guid
            };    
            currentFilters.push(naFilter);
        }
        //#endregion

        //#region ghg filter
         if (this.selectedGhgRatingWeights && this.selectedGhgRatingWeights.length > 0) {
            this.previousGhgRatings = this.selectedGhgRatingWeights
            const ghgRatingFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "ghgRatingWeight",
                    isDynamicProperty: false,
                    type: DataType.Number,
                    isNullable: true,
                },
                filterValue: this.selectedGhgRatingWeights || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            currentFilters.push(ghgRatingFilter);
        }
        //#endregion

        //#region vessel type filter
        if (this.mclFilters.RS_VesselTypes && this.mclFilters.RS_VesselTypes.length > 0) {
            currentFilters =  currentFilters.concat(this.mclFilters.RS_VesselTypes)
    }
    //#endregion

        //#region dwt values
        if (this.dwtFilterActive) {
            this.previousDwt = {first : this.dwtFirstFilter, second : this.dwtSecondFilter}
            currentFilters.push(QueryFilter.getQuery('dwt', this.dwtFirstFilter ? this.dwtFirstFilter : 0, 'ge', DataType.Number, true));
            currentFilters.push(QueryFilter.getQuery('dwt', this.dwtSecondFilter ? this.dwtSecondFilter : 0, 'le', DataType.Number, true));
        }
        //#endregion

        //#region age values
          if (this.ageFilterActive) {
            this.previousAge = {first : this.ageFirstFilter, second : this.ageSecondFilter}
            currentFilters.push(QueryFilter.getQuery('age', this.ageFirstFilter ? this.ageFirstFilter : 0, 'ge', DataType.Number, true));
            currentFilters.push(QueryFilter.getQuery('age', this.ageSecondFilter ? this.ageSecondFilter : 0, 'le', DataType.Number, true));
        }
        //#endregion

        //#region vessel status filter
        if (this.mclFilters.RS_VesselStatuses && this.mclFilters.RS_VesselStatuses.length > 0) {
        currentFilters = currentFilters.concat(this.mclFilters.RS_VesselStatuses)
        }
            //#endregion
        
        //#region state filter
        if (this.selectedStates && this.selectedStates.length > 0) {
            this.previousStates = this.selectedStates
            const classFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "inspectionState",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: LookupValueQuery.InspectionStates,
                    isNullable: true,
                },
                filterValue: this.selectedStates || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };

            currentFilters.push(classFilter);
        }
        //#endregion

        this.itemSource = this.getItemSource(currentFilters);
    }

    //#region Multi Checked List dialog filters
    public cachedMultipleLookups: { [lookup: string]: MultiLookupModel[] } = {};

     openMCLDialog = (type: string) => {
        let lookup = null;
        if (type == "vessel_types")
            lookup = LookupValueQuery.VesselTypes;
        else if (type == "vessel_statuses")
            lookup = LookupValueQuery.VesselStatuses;
        else {
            console.error("invalid multi filter type")
        }
        const displayText = type == "vessel_types" ? this.i18N.tr('vessel-type') : this.i18N.tr('vessel-status-text');

        this.closeAllFilters();

        const cachedMultiLookups = this.cachedMultipleLookups[lookup] ? this.cachedMultipleLookups[lookup] : RightShipMultiLookupModels.getMultiLookupModel(lookup);

        let filterValues: { [filterProperty: string]: number[] } = null;
        if (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1 && this.mclFilters[lookup] && this.mclFilters[lookup].length > 0) {
            filterValues = {};
            this.mclFilters[lookup].forEach(x => {
                filterValues[x.filterProperty.name] = x.filterValue;
            });
        }

        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.MultiCheckedListDialog, {
            multiLookups: cachedMultiLookups,
            title: displayText,
            selectedIds: filterValues,
            onApply: (multiLookups: MultiLookupModel[]) => {

                this.mclFilters[lookup] = [];

                const result = RightShipMultiLookupModels.getMultiLookupFilters(lookup, displayText, multiLookups);

                this.mclFilters[lookup] = result.filters;

                if (lookup == LookupValueQuery.VesselTypes) {
                    this.vesselTypeDisplayText = result.filterDisplayText;
                    this.vesselTypeDescription = result.filterDescription;
                }
                if (lookup == LookupValueQuery.VesselStatuses) {
                    this.vesselStatusDisplayText = result.filterDisplayText;
                    this.vesselStatusDescription = result.filterDescription;
                }

                this.cachedMultipleLookups[lookup] = multiLookups;

                this.setItemSource();
            }
        }, true, false, false, 'right');
    }

    //#endregion

    //#region rating filter
        public showSafetyRatingFilter: boolean = false;
        public selectedSafetyRatings: number[] = [];
        public mobileSafetyRatings: number[] = [];
        public previousSafetyRatings : number[] = [];

        public toggleSafetyRatingFilters() {

            //If freemium send event, open dialog and return
            if(this.isLimitedSubscription){
                this.eventAggregator.publish(Messages.unlockFeature, PlatformFeatureKeys.vesselsSearch);
                return;
            }

            if (!this.showSafetyRatingFilter) {
                this.closeAllFilters();
            }
            this.showSafetyRatingFilter = !this.showSafetyRatingFilter;
        }
        
        public safetyRatingSetSelectedFilter() {
            this.selectedFilter = {
                title: "Rating",
                clear: () => {
                    this.clearSafetyRatingFilter();
                },
                apply: () => {
                    const ratings = (this.mobileSafetyRatings.map(r => new RatingItem(true, r, r == -1? -1 : -3))); //if rating is -1 we set the rating type to Na (-1) and if its not -1 we set it to full rating (-3)
                    if(ratings?.length > 0) {
                        this.selectedSafetyRatings = this.selectedSafetyRatings.concat(ratings.map(x => x.rating));
                    }
                    this.showSafetyRatingFilter = false;
                }
            }
        }

        public applySafetyRatingFilter(ratings: RatingItem[]) {
                this.selectedSafetyRatings = [];
                if (ratings?.length > 0) {
                    this.selectedSafetyRatings = this.selectedSafetyRatings.concat(ratings.map(x => x.rating));
                }
    
            this.setItemSource();
    
            this.showSafetyRatingFilter = false;
        }
    
        public clearSafetyRatingFilter() {
            this.selectedSafetyRatings = [];
            this.mobileSafetyRatings = [];
            this.setItemSource();
        }
    
        @computedFrom("selectedSafetyRatings", "selectedSafetyRatings.length")
        public get safetyRatingFilterActive() {
            return this.selectedSafetyRatings && this.selectedSafetyRatings.length > 0;
        }
   
       //#endregion

    //#region ghg rating
    public selectedGhgRatingWeights: number[] = [];
    public mobileGhgRatingWeights: number[] = [];
    public showGhgRatingFilter: boolean = false;
    public previousGhgRatings: number[] = [];

    public toggleGhgRatingFilters() {

        //If freemium send event, open dialog and return
        if(this.isLimitedSubscription){
            this.eventAggregator.publish(Messages.unlockFeature, PlatformFeatureKeys.vesselsSearch);
            return;
        }

        if (!this.showGhgRatingFilter) {
            this.closeAllFilters();
        }
        this.showGhgRatingFilter = !this.showGhgRatingFilter;
    }

    public ghgSetSelectedFilter() {
        this.selectedFilter = {
            title: "GHGRating",
            clear: () => {
                this.clearGhgRatingFilter();
            },
            apply: () => {
                this.showGhgRatingFilter = false;
            }
        }
    }

    public applyGhgRating(items: number[]) {
        this.selectedGhgRatingWeights = items;
        this.setItemSource();
        this.toggleGhgRatingFilters();
    }

    public clearGhgRatingFilter() {
        this.selectedGhgRatingWeights = [];
        this.mobileGhgRatingWeights = [];
        this.setItemSource();
    }

    @computedFrom("selectedGhgRatingWeights", "selectedGhgRatingWeights.length")
    public get ghgRatingFilterActive() {
        return this.selectedGhgRatingWeights && this.selectedGhgRatingWeights.length > 0;
    }

    //#endregion

    //#region vessel type filter
    public vesselTypeDisplayText: string = this.i18N.tr('vessel-type');
    public vesselTypeDescription: string = "";
 
    public clearVesselTypeFilter(reload: boolean = true) {
        const lookup = LookupValueQuery.VesselTypes;
        if (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1)
            this.mclFilters[lookup] = [];
        this.vesselTypeDescription = "";
        this.vesselTypeDisplayText = this.i18N.tr('vessel-type');
        if (reload)
            this.setItemSource();
    }
 
    @computedFrom("mclFilters", "mclFilters.RS_VesselTypes", "mclFilters.RS_VesselTypes.length")
    public get vesselTypeFilterActive() {
        const lookup = LookupValueQuery.VesselTypes;
        return (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1 && this.mclFilters[lookup] && this.mclFilters[lookup].length > 0);
    }
    //#endregion

    //#region dwt filter

    public dwtDefaults: { low: number, high: number } = {low: 0, high: 565000};
    public dwtFirstFilter: number = this.dwtDefaults.low;
    public dwtSecondFilter: number = this.dwtDefaults.high;
    public showDwtFilter: boolean = false; 
    public dwtIsApplied: boolean = false;
    public previousDwt: {first: number, second: number} = {first: this.dwtDefaults.low, second: this.dwtDefaults.high}

    public toggleDwtFilters() {
        if (!this.showDwtFilter) {
            this.closeAllFilters();
        }
        this.showDwtFilter = !this.showDwtFilter;
    }

    public dwtSetSelectedFilter() {
        this.selectedFilter = {
            title: "dwt",
            clear: () => {
                this.clearDwtFilter();
            },
            apply: () => {
                this.showDwtFilter = false;
            }
        }
    }

    public applyDwtFilter(filterValue: { low: number, high: number } = null) {
        if (filterValue) {
            this.dwtFirstFilter = filterValue.low;
            this.dwtSecondFilter = filterValue.high;
            this.dwtIsApplied = true;
        }

        this.setItemSource();
        this.toggleDwtFilters();
    }

    public clearDwtFilter() {
        this.dwtFirstFilter = this.dwtDefaults.low;
        this.dwtSecondFilter = this.dwtDefaults.high;

        this.dwtIsApplied = false;
        this.setItemSource();
    }

    @computedFrom("dwtFirstFilter", "dwtSecondFilter")
    public get dwtFilterActive() {
        return this.dwtFirstFilter > this.dwtDefaults.low || this.dwtSecondFilter < this.dwtDefaults.high;
    }
  
    //#endregion

    //#region age filter
    public ageDefaults: { low: number, high: number } = { low: 0, high: 100 };
    public ageFirstFilter: number = this.ageDefaults.low;
    public ageSecondFilter: number = this.ageDefaults.high;
    public previousAge: {first: number, second: number} = {first: this.ageDefaults.low, second: this.ageDefaults.high}

    public showAgeFilter: boolean = false;
    public ageIsApplied: boolean = false;
 
    public toggleAgeFilters() {
        if (!this.showAgeFilter) {
            this.closeAllFilters();
        }
        this.showAgeFilter = !this.showAgeFilter;
    }
    
    public ageSetSelectedFilter() {
        this.selectedFilter = {
            title: "Age",
            clear: () => {
                this.clearAgeFilter();
            },
            apply: () => {
                this.setItemSource();
                this.showAgeFilter = false;
            }
        }
    }

    public applyAgeFilter(filterValue: { low: number, high: number } = null) {
        if (filterValue) {
            this.ageFirstFilter = filterValue.low;
            this.ageSecondFilter = filterValue.high;
            this.ageIsApplied = true;
        }
 
        this.setItemSource();
        this.toggleAgeFilters();
    }
 
    public clearAgeFilter() {
        this.ageFirstFilter = this.ageDefaults.low;
        this.ageSecondFilter = this.ageDefaults.high;

        this.ageIsApplied = false;
        this.setItemSource();
    }
 
    @computedFrom("ageFirstFilter", "ageSecondFilter")
    public get ageFilterActive() {
        return this.ageFirstFilter > this.ageDefaults.low || this.ageSecondFilter < this.ageDefaults.high;
    }
 
    //#endregion

    //#region vessel status filter
    public vesselStatusDisplayText: string = this.i18N.tr('vessel-status-text');
    public vesselStatusDescription: string = "";

    public clearVesselStatusFilter(reload: boolean = true) {
        const lookup = LookupValueQuery.VesselStatuses;
        if (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1)
            this.mclFilters[lookup] = [];
        this.vesselStatusDescription = "";
        this.vesselStatusDisplayText = this.i18N.tr('vessel-status-text');
        if (reload)
            this.setItemSource();
    }

    @computedFrom("mclFilters", "mclFilters.RS_VesselStatuses", "mclFilters.RS_VesselStatuses.length")
    public get vesselStatusFilterActive() {
        const lookup = LookupValueQuery.VesselStatuses;
        return (this.mclFilters && Object.keys(this.mclFilters).indexOf(lookup) > -1 && this.mclFilters[lookup] && this.mclFilters[lookup].length > 0);
    }
    //#endregion

    //#region state filter
    public selectedStates: number[] = [];
    public mobileStates: number[] = [];
    public showStateFilter: boolean = false;
    public states;
    public previousStates: number[] = [];

    public toggleStateFilters() {

        //If freemium send event, open dialog and return
        if(this.isLimitedSubscription){
            this.eventAggregator.publish(Messages.unlockFeature, PlatformFeatureKeys.vesselsSearch);
            return;
        }

        if (!this.showStateFilter) {
            this.closeAllFilters();
        }
        this.showStateFilter = !this.showStateFilter;
        
    }

    public stateSetSelectedFilter () {
        this.selectedFilter = {
            title: "State",
            clear: () => {
                this.clearStateFilter();
            },
            apply: () => {
                this.showStateFilter = false;
            }
        }
    }

    public applyStates(items: any[]) {
        this.selectedStates = items.map(x => x.id);
        this.setItemSource();
        this.toggleStateFilters();
    }

    public clearStateFilter() {
        this.selectedStates = [];
        this.mobileStates = [];
        this.setItemSource();
    }

    @computedFrom("selectedStates", "selectedStates.length")
    public get stateFilterActive() {
        return this.selectedStates && this.selectedStates.length > 0;
    }

    //#endregion
    
    filterKeyDown($event) {
        const e: KeyDownEvent = $event.detail;

        if (e.key == "Enter") {
            this.setItemSource();
        }
    }

    keywordsChanged() {
        if (!this.keywordProperties) return;

        const toLowerKeywords = this.keywordProperties.map(x => x.toLowerCase());
        const keywordFilters = this.initialFilters.filter(x => toLowerKeywords.indexOf(x.filterProperty.name.toLowerCase()) != -1);

        keywordFilters.forEach(x => {
            const isActive = !this.filters || !this.filters.some(f => f.name == x.filterProperty.name && !f.filterActive);
            x.filterValue = isActive || (x.filterValue == "" && x.filterValue == this.keywords)
                ? this.keywords
                : null;
        });
    }

    clearKeywords() {
        this.keywords = "";
        this.keywordsChanged();
        this.setItemSource();
    }

    toggleMobileFilterDialog() {
        this.isMobileFilterOpen = !this.isMobileFilterOpen;
    }    
    
    hideMobileFilters() {
        this.selectedSafetyRatings = this.previousSafetyRatings
        this.selectedGhgRatingWeights = this.previousGhgRatings
        this.dwtFirstFilter = this.previousDwt.first
        this.dwtSecondFilter = this.previousDwt.second
        this.ageFirstFilter = this.previousAge.first
        this.ageSecondFilter = this.previousAge.second
        this.selectedStates = this.previousStates
        this.isMobileFilterOpen = false;
    }

    public selectedFilters : any[] = []

    public mobileFilterApply(toggleDialog: boolean = true) {
        if(toggleDialog)
            this.toggleMobileFilterDialog();

        this.selectedStatusFilter = [];

       this.selectedFilters.forEach(x => {
            x.apply();
       })
       this.selectedFilters = [];

        //Refresh itemSource irrelevant of number of mobileSelectedFilters. Users may unselect all filters (resulting in no selected filters)
        this.setItemSource();
    }

    public mobileApplySelectedFilter() {
        if (this.selectedFilter) {
            this.selectedFilters.push(this.selectedFilter);
            this.selectedFilter = null;
        }
    }

    clearAllFilters() {
        this.clearSafetyRatingFilter()
        this.clearGhgRatingFilter()
        this.clearVesselTypeFilter()
        this.clearDwtFilter()
        this.clearAgeFilter()
        this.clearVesselStatusFilter()
        this.clearStateFilter()
        this.includePreviousVesselNames = false;
    }

    closeAllFilters() {
        this.showSafetyRatingFilter = false;
        this.showGhgRatingFilter = false;
        this.showDwtFilter =false;
        this.showAgeFilter = false;
        this.showStateFilter = false;
    }

    @computedFrom("safetyRatingFilterActive", "ghgRatingFilterActive", "vesselStatusFilterActive", "dwtFilterActive", "ageFilterActive", "vesselStatusFilterActive", "stateFilterActive")
    public get activeFilter() {
        return this.safetyRatingFilterActive || this.ghgRatingFilterActive || this.vesselStatusFilterActive || this.dwtFilterActive || this.ageFilterActive || this.vesselStatusFilterActive|| this.stateFilterActive
    }

    public determineActivationStrategy() {
        return activationStrategy.replace;
    }
}
